import { FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { getInitials } from '../../utils/format';

/**
 * Encabezado superior fijo de cada dashboard: título de la vista +
 * avatar/logout del usuario autenticado.
 *
 * @param {{ title: string, subtitle?: string }} props
 */
export default function AppHeader({ title, subtitle }) {
  const { user, logout } = useAuth();

  return (
    <header className="pulso-header">
      <div className="pulso-header__info">
        {subtitle && <span className="pulso-header__eyebrow">{subtitle}</span>}
        <h1 className="pulso-header__title">{title}</h1>
      </div>
      <div className="pulso-header__user">
        <span className="pulso-avatar" aria-hidden="true">
          {getInitials(user?.name)}
        </span>
        <button
          type="button"
          className="pulso-icon-btn"
          onClick={logout}
          aria-label="Cerrar sesión"
        >
          <FiLogOut />
        </button>
      </div>
    </header>
  );
}
